var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenompools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 61,
    viewBox: "0 0 164.965 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      paintOrder: "stroke",
      fill: "rgb(0, 0, 0)"
    },
    cx: 82.482,
    cy: 81.632,
    rx: 81.941,
    ry: 81.194,
    transform: "matrix(0.999982, -0.005997, 0.005997, 0.999982, -0.80239, 0.481354)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_4556)",
    style: {},
    transform: "matrix(0.699272, 0, 0, 0.699272, 24.659639, 24.659645)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.0041 13.6363C67.6213 13.6363 55.924 10.7662 55.924 7.21973H52.644C52.644 11.2049 65.8132 14.444 82.0041 14.444C98.195 14.444 111.36 11.2049 111.36 7.21973H108.08C108.08 10.7457 96.3828 13.6363 82.0041 13.6363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0039 60.4947C46.3913 60.4947 17.4207 53.3689 17.4207 44.6113H9.29858C9.29858 54.4718 41.9141 62.4914 82.0039 62.4914C122.094 62.4914 154.705 54.4718 154.705 44.6113H146.583C146.583 53.3853 117.612 60.4947 82.0039 60.4947Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0042 99.917C41.8242 99.917 9.16349 91.881 9.16349 82H0.00415039C0.00415039 93.1233 36.7894 102.168 82.0042 102.168C127.219 102.168 164.004 93.1233 164.004 82H154.841C154.841 91.881 122.168 99.917 82.0042 99.917Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0039 135.275C46.3913 135.275 17.4207 128.149 17.4207 119.392H9.29858C9.29858 129.252 41.9141 137.272 82.0039 137.272C122.094 137.272 154.705 129.236 154.705 119.396H146.583C146.583 128.149 117.612 135.275 82.0039 135.275Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0041 163.197C67.6213 163.197 55.924 160.327 55.924 156.78H52.644C52.644 160.761 65.8132 164 82.0041 164C98.195 164 111.36 160.761 111.36 156.78H108.08C108.08 160.319 96.3828 163.197 82.0041 163.197Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0579 64.4561C50.8112 63.6361 39.5648 62.0576 30.3275 59.7862L29.0975 59.4746C29.3632 60.0147 29.6574 60.5402 29.979 61.0489C32.9146 65.6491 37.7322 68.9989 41.9347 72.4839C44.7186 74.8127 49.5319 81.4178 51.8894 88.5805C52.9923 91.9343 53.9396 95.3209 54.8457 98.7362C59.7083 99.22 64.7841 99.5561 70.0157 99.7857C68.2281 97.7357 66.9159 95.1774 65.8294 92.3197C63.1742 85.4135 61.99 78.029 62.3526 70.6389C62.4822 68.5673 62.7177 66.5037 63.0579 64.4561Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.983 64.4557C101.329 66.5151 101.569 68.5911 101.701 70.6753C102.068 78.0657 100.883 85.4511 98.2238 92.3562C97.1332 95.1975 95.8293 97.7435 94.0499 99.7894C99.261 99.5762 104.325 99.2237 109.171 98.7399C110.077 95.3328 111.02 91.9298 112.123 88.5801C114.484 81.4174 119.294 74.7877 122.078 72.4794C126.28 68.9862 131.098 65.6446 134.033 61.0444C134.353 60.5398 134.646 60.0184 134.911 59.4824L133.681 59.7899C124.451 62.0572 113.217 63.6357 100.983 64.4557Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0041 104.742H81.918C81.7745 104.742 81.5573 104.742 81.299 104.742C72.6111 104.722 64.128 104.377 56.092 103.721C57.6459 110.482 59.5934 122.171 60.9177 127.792C61.4581 130.245 62.4002 132.592 63.7059 134.738C69.5648 135.148 75.7065 135.386 81.9877 135.386C88.2689 135.386 94.3903 135.168 100.245 134.742C101.564 132.591 102.514 130.235 103.058 127.772C104.374 122.171 106.313 110.47 107.879 103.709C99.6464 104.394 90.938 104.742 82.0041 104.742Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2279 139.527C72.1106 142.258 76.9363 143.148 81.7579 143.303H82.0778C86.9076 143.148 91.7701 142.258 95.6897 139.531C91.2166 139.736 86.637 139.847 81.9917 139.847C77.3464 139.847 72.7256 139.736 68.2279 139.527Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6538 55.9861C44.3577 57.8844 53.677 59.2333 63.845 59.9713C64.1197 58.4789 64.4026 56.9865 64.665 55.5023C65.6367 49.8647 64.3738 44.2396 60.3189 39.9223C58.1541 37.6466 55.4618 35.9398 52.4799 34.9531C49.4571 33.9484 46.2377 33.6812 43.0907 34.174C33.6607 35.6336 27.3754 43.6041 27.3221 51.9312C27.3221 52.3166 27.3222 52.702 27.355 53.0874C30.3848 54.2647 33.4917 55.2332 36.6538 55.9861Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.726 39.9548C99.6711 44.2762 98.3961 49.8973 99.3842 55.5348C99.6384 57.0108 99.9172 58.4868 100.204 59.9669C110.36 59.233 119.667 57.88 127.362 55.9858C130.526 55.2337 133.634 54.2651 136.665 53.0871C136.69 52.7017 136.702 52.3122 136.698 51.9268C136.649 43.5628 130.392 35.6047 120.938 34.1738C117.792 33.6942 114.576 33.9754 111.561 34.9938C108.582 35.9789 105.891 37.6828 103.726 39.9548Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0041 0.807688C96.3828 0.807688 108.08 3.67764 108.08 7.22004H111.36C111.36 3.23894 98.1909 0 82.0041 0C65.8173 0 52.644 3.23894 52.644 7.22004H55.924C55.924 3.68584 67.6213 0.807688 82.0041 0.807688Z",
    fill: "url(#paint0_linear_487_4556)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0039 28.7292C117.612 28.7292 146.583 35.855 146.583 44.6126H154.705C154.705 34.7726 122.09 26.7324 82.0039 26.7324C41.9182 26.7324 9.29858 34.7521 9.29858 44.6126H17.4207C17.4207 35.855 46.3913 28.7292 82.0039 28.7292Z",
    fill: "url(#paint1_linear_487_4556)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0041 149.56C65.8132 149.56 52.644 152.799 52.644 156.78H55.924C55.924 153.245 67.6213 150.367 82.0041 150.367C96.3869 150.367 108.08 153.237 108.08 156.78H111.36C111.36 152.799 98.1909 149.56 82.0041 149.56Z",
    fill: "url(#paint2_linear_487_4556)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9479 68.5553C18.7779 71.8353 9.17976 76.6487 9.17976 81.9992H0C0 75.7959 11.4471 70.2404 29.4133 66.5381C31.2214 66.6652 32.6482 67.477 33.9479 68.5553ZM134.599 66.5381C132.791 66.6611 131.36 67.477 130.089 68.5553C145.259 71.8353 154.869 76.6446 154.869 81.9992H164.029C164 75.7959 152.549 70.2404 134.583 66.5381H134.599Z",
    fill: "url(#paint3_linear_487_4556)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3044 105.046C32.517 107.6 17.4044 113.07 17.4044 119.396H9.28223C9.28223 112.279 26.2808 106.12 50.8111 103.246L51.0532 103.271C53.5091 103.57 54.3044 105.046 54.3044 105.046ZM113.172 103.242L112.93 103.267C110.47 103.57 109.695 105.046 109.695 105.046C131.487 107.6 146.595 113.07 146.595 119.396H154.718C154.705 112.274 137.707 106.116 113.172 103.242Z",
    fill: "url(#paint4_linear_487_4556)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_487_4556",
    x1: 82.0041,
    y1: 7.22004,
    x2: 82.0041,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_487_4556",
    x1: 82.0039,
    y1: 44.6126,
    x2: 82.0039,
    y2: 26.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_487_4556",
    x1: 82.0041,
    y1: 156.78,
    x2: 82.0041,
    y2: 149.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_487_4556",
    x1: 82,
    y1: 81.9992,
    x2: 82,
    y2: 66.5381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_487_4556",
    x1: 82.004,
    y1: 119.392,
    x2: 82.004,
    y2: 103.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_4556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 164,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenompools);
export default __webpack_public_path__ + "static/media/venompools.f3e125657af076716f9b9b5a5ce46832.svg";
export { ForwardRef as ReactComponent };